export namespace GenericDocConstants {
    export enum PostingStatusType {
        DRAFT = 'DRAFT',
        FINAL = 'FINAL'
    }
} 